const GalleryListPage = () => {
  return (
    <div>
      <h6>Gallery List Page</h6>
    </div>
  );
};

export default GalleryListPage;
